<script>
import axios from '@/axios'
export default {
  props : {
    liveId : String,
    privateStatus : String
  },
    data() {
        return  {
            showExplan : false,
            changePrivateStatus : null
        }
    },
    name : 'toggleButton',
    methods : {
        toggleExplan() {
          if(this.showExplan === true) {
            this.changePrivateStatus = 'private'
          } else {
            this.changePrivateStatus = 'public'
          }
          this.showExplan = !this.showExplan

  const sendData = {
  liveId: this.liveId,
  privateStatus: this.changePrivateStatus
};

axios.put("/api/liveStatusUpdate", sendData, {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})
.then(response => {
  console.log(response);
})
.catch(error => {
  console.error('Error while sending data:', error);
});



        }
    },
    mounted() {
      if(this.privateStatus === 'public') {
            this.showExplan = true;
            document.getElementById(`toggle${this.liveId}`).checked = true;
          } else if( this.privateStatus === 'private') {
            this.showExplan = false;
          }
    }
}

</script>

<template >
  <input type="checkbox" class='toggleIs' :id="'toggle' + liveId" hidden @click="toggleExplan">
  <label :for="'toggle' + liveId" class="toggleSwitch" >
      <div class="toggleText">{{ showExplan ? 'ON' : 'OFF' }}</div>
      <span class="toggleButton"></span>
  </label>
</template>

<style scoped>

/* ----토글---- */
.toggleSwitch {
  width: 70px;
  height: 30px;
  display: block;
  position: relative;
  border-radius: 30px;
  background-color: #fff;
  box-shadow: 0 0 16px 3px rgba(0 0 0 / 15%);
  cursor: pointer;
  margin-left: 30px;
}

.toggleSwitch .toggleButton {
  width: 22px;
  height: 22px;
  position: absolute;
  top: 50%;
  left: 4px;
  transform: translateY(-50%);
  border-radius: 50%;
  background: #f03d3d;
}

.toggleIs:checked ~ .toggleSwitch {
  background: #f03d3d;
}

.toggleIs:checked ~ .toggleSwitch .toggleButton {
  left: calc(100% - 28px);
  background: #fff;
}

.toggleIs:checked ~ .toggleSwitch .toggleText {
  left: 4px;
  color: #fff;
}

.toggleSwitch .toggleText {
  position: absolute;
  top: 50%;
  left: calc(100% - 35px);
  transform: translateY(-50%);
  border-radius: 50%;
  transition: all 0.2s ease-in;
}

</style>